export const HiddenLink = {
    baseStyle: () => ({
        _hover: {
            textDecoration: "none",
        },
    }),
};
